export enum AuditActionTypeEnum {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
  ARCHIVE = 'Archive',
}
